/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespDetails_user = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailFramingOptions_user" | "PdpSharedDetailReference_user">;
    readonly " $refType": "PdpRespDetails_user";
};
export type PdpRespDetails_user$data = PdpRespDetails_user;
export type PdpRespDetails_user$key = {
    readonly " $data"?: PdpRespDetails_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDetails_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespDetails_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailFramingOptions_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailReference_user",
      "args": null
    }
  ]
};
(node as any).hash = '54048e6e50876137ff7e44a7f03cdf1a';
export default node;
